import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import { PAGE_URL } from "../services/constant";

const ApiKeyPermissionGroupCredentials = React.lazy(() =>
    import('../ApiKeyPermissionGroupCredentials')
);

const apiKeyPermissionGroupCredentialsRoutesRegistry = [
    {
        path: PAGE_URL.API_KEY_PERMISSION_GROUP_CREDENTIALS_PAGE,
        element: <ApiKeyPermissionGroupCredentials />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default apiKeyPermissionGroupCredentialsRoutesRegistry;
